export default "__VITE_ASSET__ZIuASVRw__"